<template>
	<div class="product-store-change--modal">
		<CheckboxList
			v-model="checkedList"
			:checkboxList="dataList"
			:girdColumn="2"
		/>
		<div class="btn-wrap-main">
			<button class="btn-main blue bordered" type="button" @click="init">
				초기화
			</button>
			<button class="btn-main blue" type="button" @click="register">
				{{ checkedList.length }} 등록
			</button>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import CheckboxList from '@/components/CheckboxList';

	export default {
		name: 'ProductStoreChange',
		data() {
			return {
				checkedList: [],
			};
		},
		components: {
			CheckboxList,
		},
		computed: {
			...mapState('productList', ['storeList']),
			dataList: {
				get() {
					return this.storeList.map(item => ({
						...item,
						value: item.name,
					}));
				},
			},
		},

		methods: {
			init() {
				this.checkedList = [];
			},
			async register() {
				await this.$store.dispatch(
					'productList/changeStoreBatch',
					this.checkedList
				);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.product-store-change--modal {
		height: 100%;
		position: relative;
		padding-bottom: 118px;

		.product-store-change__list {
			overflow: auto;
			height: 100%;
			margin: 18px 0 0 0;
			border-top: solid 1px #ebebed;
			border-bottom: solid 1px #ebebed;

			&:after {
				content: '';
				display: block;
				clear: both;
			}
		}

		.product-store-change__list__item {
			float: left;
			display: block;
			width: 50%;

			&:hover {
				background: #f4f7fa;
			}
		}

		.product-store-change__label {
			overflow: hidden;
			cursor: pointer;
			display: block;
			width: 100%;
			height: 40px;
			padding: 10px;
			line-height: 20px;
			font-size: 0;
		}

		.product-store-change__input,
		.product-store-change__name {
			cursor: pointer;
			display: inline-block;
			line-height: 20px;
			font-size: 0.875rem;
		}

		.product-store-change__input {
			float: left;
			margin: 4px 4px 0 0;
		}

		.product-store-change__name {
			overflow: hidden;
			display: block;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
	}
</style>
